/* ============================================================
   mylight.pk | IMAGE PROTECTION — JS
   Added: 2026-08-02
   Purpose: Lightweight, app-free protection against casual image
            copying / downloading on product photos & site images.

   WHAT THIS DOES:
     - Blocks the right-click / long-press context menu, but ONLY
       when the click target is an <img> element (event delegation
       on document — no per-image listeners, near-zero overhead).
       On most mobile browsers (e.g. Chrome Android), long-press on
       an image also fires "contextmenu", so this covers long-press
       saving there too. iOS Safari's long-press "Save Image" callout
       is blocked separately via CSS (-webkit-touch-callout: none in
       mylight-image-protection.css).
     - Blocks native HTML5 drag-out-to-desktop, again ONLY for <img>
       elements.

   WHAT THIS DOES NOT DO:
     - Does NOT disable right-click anywhere else on the site.
     - Does NOT block clicks, taps, links, buttons, variant
       selection, Add to Cart, checkout, or the product image zoom
       (zoom is a click/tap interaction, untouched by this script).
     - Does NOT block normal text selection on the page.
     - This is a deterrent for casual copying only — screenshots and
       browser dev tools can still capture images, as is true for
       any website.

   TO REMOVE:
     1. Delete this file.
     2. Delete assets/mylight-image-protection.css
     3. Remove the <script src="{{ 'mylight-image-protection.js' ..."
        line (marked "IMAGE PROTECTION — START/END") near the bottom
        of <body> in layout/theme.liquid
     4. Remove the matching <link> block near the top of <head> in
        layout/theme.liquid
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener(
    'contextmenu',
    function (event) {
      if (event.target && event.target.tagName === 'IMG') {
        event.preventDefault();
      }
    },
    false
  );

  document.addEventListener(
    'dragstart',
    function (event) {
      if (event.target && event.target.tagName === 'IMG') {
        event.preventDefault();
      }
    },
    false
  );
})();
/* ============================================================
   mylight.pk | IMAGE PROTECTION — JS END
   ============================================================ */
